module.exports = __webpack_public_path__ + "f54c62431f4c6287e47a44f2f85dce1d.MP3";